module.exports = __webpack_public_path__ + "img/time_and_expense.fb673b5f.svg";